<template>
    <b-navbar toggleable="lg" :fixed="fixed ? 'top': ''" class="site-header" type="dark">
        <div class="w-100" style="background: rgba(0, 0, 0, 0.3)">
            <b-container class="container-pre-header">
                <b-navbar-nav class="site-pre-header" style="flex-direction: row">
                    <b-nav-item v-if="!isMobileLayout" @click="loginModal = true" class="ml-auto text-light"><span v-tr>Sign In|Se connecter</span></b-nav-item>
                    <b-nav-item href="tel:+18008904213" class="ml-2 text-secondary">+1 (800) 890-4213</b-nav-item>
                    <b-nav-item v-scroll-to="'#contact-us'" class="ml-2 text-secondary"><span v-tr>Contact Us|Contactez-nous</span>
                    </b-nav-item>
                    <b-nav-item class="ml-2 text-secondary" @click="changeLanguage"><span v-tr>FR|EN</span></b-nav-item>
                </b-navbar-nav>
            </b-container>
        </div>
        <b-container class="site-header-container">
            <b-navbar-brand v-if="isMobileLayout" to="/">
                <e-img class="mb-2" width="100" src="img/branding/logo-inline-white-sm.png" alt="Eye-In Media Logo"/>
<!--                <e-img height="28" src="img/branding/logo-inline-white-sm.png" alt="Eye-In Media Logo"/>-->
            </b-navbar-brand>

            <b-navbar-toggle target="navbar-toggle-collapse">
                <template #default="{ expanded }">
                    <span>Menu <i v-if="expanded" class="fal fa-chevron-up"></i>
                        <i v-else class="fal fa-chevron-down"></i>
                    </span>
                </template>
            </b-navbar-toggle>

            <b-collapse id="navbar-toggle-collapse" is-nav>
                <b-navbar-nav class="w-100">
                    <b-navbar-brand v-if="!isMobileLayout" class="mr-auto" to="/">
                        <e-img height="40" src="img/branding/logo-20-years-white-sm.png" style="margin-top: -5px;" alt="Eye-In Media Logo"/>
<!--                        <e-img height="32" src="img/branding/logo-inline-white-sm.png" alt="Eye-In Media Logo"/>-->
                    </b-navbar-brand>
                    <template v-if="!searchVisible">
                        <menu-dropdown :to="'/digital-signage|/affichage-numerique'|tr">
                            <template #button-content><span v-tr>Digital Signage|Affichage numérique</span></template>
                            <b-dropdown-item :to="'/digital-signage|/affichage-numerique'|tr">
                                <i class="fal fa-tv-alt"></i>
                                <span v-tr>Discover Digital Signage|Affichage numérique</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/interactive-touch-kiosk|/affichage-numerique/kiosk-tactile-interactif'|tr">
                                <i class="fal fa-rectangle-vertical-history"></i>
                                <span v-tr>Wayfinding Kiosk|Kiosque tactile de navigation</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video'|tr">
                                <i class="fal fa-gallery-thumbnails"></i>
                                <span v-tr>Video Walls|Murs vidéo</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/holograms|/affichage-numerique/hologrammes'|tr">
                                <i class="fal fa-atom"></i>
                                <span v-tr>3D Holograms|Hologrammes 3D</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/menuboards|/affichage-numerique/menus-restaurants'|tr">
                                <i class="fal fa-utensils"></i>
                                <span v-tr>Digital Menu Boards|Menus numériques</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/healthcare|/affichage-numerique/sante-et-hopitaux'|tr">
                                <i class="fal fa-hospital"/>
                                <span v-tr>Signage for Healthcare|Affichage pour la santé</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/schools-and-education|/affichage-numerique/ecoles-et-education'|tr">
                                <i class="fal fa-graduation-cap"/>
                                <span v-tr>Signage for Education|Affichage pour l'éducation</span>
                            </b-dropdown-item>
                            <!--                        <b-dropdown-item to="/digital-signage/kiosks">
                            <i class="fal fa-"></i> <span v-tr>Digital Kiosks</span>
                            </b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/digital-signage/eye-intelligence">
                            <i class="fal fa-"></i> <span v-tr></span>Eye-Intelligence Digital Signage CRM
                            </b-dropdown-item>-->
                            <b-dropdown-item :to="'/digital-signage/storyboard/infinite|/affichage-numerique/storyboard/infinite'|tr">
                                <i class="fal fa-paint-brush-alt"></i>
                                <span v-tr>Content Design Software|Création de contenu</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/media-player/eye-infinite-player|/affichage-numerique/logiciel-multimedia/eye-infinite-player'|tr">
                                <i class="fal fa-play"></i>
                                <span v-tr>Media Player Software|Logiciel Media Player</span>
                            </b-dropdown-item>

                            <!--                        <b-dropdown-item to="/digital-signage/equipment">
                            <i class="fal fa-"></i> <span v-tr>Equipment & Integration</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/digital-signage/tizen">
                            <i class="fal fa-"></i> <span v-tr>Player made for Tizen</span></b-dropdown-item>-->
                            <b-dropdown-item href="https://digitalsignage.expert/s/shop?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_menu" target="_blank">
                                <i class="fal fa-cart-shopping-fast"></i>
                                <span v-tr>Online Store|Acheter en ligne</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/services|/affichage-numerique/services'|tr">
                                <i class="fal fa-tools"></i>
                                <span v-tr>Our Services|Nos services</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/digital-signage/clients|/affichage-numerique/clients'|tr">
                                <i class="fal fa-users-crown"></i>
                                <span v-tr>Our Markets & Clients|Nos clients et marchés</span>
                            </b-dropdown-item>
                        </menu-dropdown>
                        <menu-dropdown :to="'/restauration/food-force-for-restaurants|/restauration/food-force-pour-restaurants'|tr">
                            <template #button-content><span v-tr>Restaurants|Restauration</span></template>
                            <b-dropdown-item :to="'/restauration/food-force-for-restaurants|/restauration/food-force-pour-restaurants'|tr">
                                <i class="fal fa-user-chef"></i>
                                <span v-tr>FoodForce for Restaurants|FoodForce pour les restaurants</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/restauration/easy-self-ordering|/restauration/commande-autonome'|tr">
                                <i class="fal fa-bags-shopping"></i>
                                <span v-tr>Self-Ordering Application|Commande autonome</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/restauration/mev-srm-compatible|/restauration/mev-srm-compatible|/restauration/compatibilite-mev'|tr">
                                <i class="fal fa-shield-check"></i>
                                <span v-tr>Québec SRM Compatible|Compatible MEV Québec</span>
                            </b-dropdown-item>
                            <!--                            <b-dropdown-item to="/restauration/powerful-recommendations">-->
                            <!--                                <i class="fal fa-wand-magic-sparkles"></i>-->
                            <!--                                <span v-tr>Recommendations Assistant|Assistant de Recommandations</span>-->
                            <!--                            </b-dropdown-item>-->
                            <b-dropdown-item :to="'/restauration/digital-signage-for-restaurants|/restauration/affichage-numerique-pour-restaurants'|tr">
                                <i class="fal fa-tv"></i>
                                <span v-tr>Digital Signage for Restaurants|Affichage pour restaurants</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/restauration/menuboard-designer|/restauration/conception-et-design-menus'|tr">
                                <i class="fal fa-paint-brush-alt"></i>
                                <span v-tr>Menuboards Designer|Création de menus</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/restauration/codes-qr-et-demos|/restauration/codes-qr-et-demos'|tr">
                                <i class="fal fa-clapperboard-play"></i>
                                <span v-tr>Videos & Demonstrations|Vidéos et démonstrations</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/restauration/clients|/restauration/nos-clients'|tr">
                                <i class="fal fa-users-crown"></i>
                                <span v-tr>Our Clients|Nos clients</span>
                            </b-dropdown-item>
                        </menu-dropdown>
                        <menu-dropdown :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr">
                            <template #button-content><span v-tr>Social & Guest WiFi|WiFi public</span></template>
                            <b-dropdown-item :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr">
                                <i class="fal fa-wifi"></i>
                                <span v-tr>Discover Social & Guest WiFi|WiFi public & social</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux'|tr">
                                <i class="fal fa-shopping-bag"></i>
                                <span v-tr>WiFi CRM for Malls & Retail|CRM WiFi pour détaillants</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes'|tr">
                                <i class="fal fa-bus"></i>
                                <span v-tr>Transports & Bus WiFi|WiFi pour bus & transports</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi/technology|/wifi-public/technologie-et-compatibilite'|tr">
                                <i class="fal fa-router"></i>
                                <span v-tr>Cisco & Meraki Compatibility|Compatibilité Cisco & Meraki</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi/compliant-gdpr-law-25|/wifi-public/conformite-rgpd-et-loi-25'|tr">
                                <i class="fal fa-shield-check"></i>
                                <span v-tr>GDPR & Law 25 Compliant|Conformité RGPD et Loi 25</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi/services|/wifi-public/services'|tr">
                                <i class="fal fa-tools"></i>
                                <span v-tr>Our Services|Nos services</span>
                            </b-dropdown-item>
                            <b-dropdown-item :to="'/wifi/clients|/wifi-public/marches-et-clients'|tr">
                                <i class="fal fa-users-crown"></i>
                                <span v-tr>Our Markets & Clients|Nos clients et marchés</span>
                            </b-dropdown-item>
                            <!--                        <b-dropdown-item to="/wifi/geolocation"><span v-tr>Geolocation & Customer Journey</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/wifi/eye-intelligence"><span v-tr>Eye-Intelligence WiFi CRM</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/wifi/meraki"><span v-tr>WiFi made for Meraki</span></b-dropdown-item>-->
                        </menu-dropdown>
                        <!--                    <menu-dropdown>-->
                        <!--                        <template #button-content><span v-tr>Loyalty Programs</span></template>-->
                        <!--                        <b-dropdown-item to="/loyalty/services"><span v-tr>Innovative Loyalty Programs</span></b-dropdown-item>-->
                        <!--                        <b-dropdown-item to="/loyalty/confetti"><span v-tr>Discover Confetti for Place Rosemère</span></b-dropdown-item>-->
                        <!--                    </menu-dropdown>-->
                        <menu-dropdown :to="'/mobile-apps/universal-applications|/applications-mobiles/app-universelles'|tr">
                            <template #button-content><span v-tr>Mobile Applications|Apps mobile</span></template>
                            <b-dropdown-item :to="'/mobile-apps/universal-applications|/applications-mobiles/app-universelles'|tr">
                                <i class="fal fa-mobile-alt"></i>
                                <span v-tr>Universal Mobile Apps|Apps mobiles universelles</span>
                            </b-dropdown-item>
                            <b-dropdown-item to="/mobile-apps/contact-tracing">
                                <i class="fal fa-chart-network"></i>
                                <span v-tr>Contact Tracing|Suivi des contacts</span>
                            </b-dropdown-item>
                            <!--                        <b-dropdown-item to="/mobile-apps/indoor-geolocation"><span v-tr>Indoor Geolocation</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/mobile-apps/services"><span v-tr>Tailor Made Mobile Applications</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/mobile-apps/only1-generation"><span v-tr>Only1 Generation</span></b-dropdown-item>-->
                            <!--                        <b-dropdown-item to="/mobile-apps/reserve-shop"><span v-tr>Reserve and Shop</span></b-dropdown-item>-->
                        </menu-dropdown>
                        <!--                    <menu-dropdown>-->
                        <!--                        <template #button-content><span v-tr>Omnichannel Tools</span></template>-->
                        <!--                        <b-dropdown-item to="/marketing/surveys"><span v-tr>Surveys & Contests</span></b-dropdown-item>-->
                        <!--                        <b-dropdown-item to="/marketing/chat"><span v-tr>Universal Chat</span></b-dropdown-item>-->
                        <!--                        <b-dropdown-item to="/marketing/newsletter"><span v-tr>Newsletter</span></b-dropdown-item>-->
                        <!--                    </menu-dropdown>-->
                        <b-nav-item to="/blog">Blog</b-nav-item>
                        <b-nav-item :to="'/about-us|/a-propos-de-nous'|tr"><span v-tr>About Us|À propos</span></b-nav-item>
                        <template v-if="isMobileLayout">
                            <b-nav-item @click="loginModal = true"><span v-tr>Sign In|Se connecter</span></b-nav-item>
                            <b-nav-item @click="changeLanguage"><span v-tr>Français|English</span></b-nav-item>
                        </template>
                        <b-nav-item @click="showSearchBar()"><i class="fal fa-search fa-fw"></i></b-nav-item>
                    </template>
                    <template v-else>
                        <b-nav-item v-show="searchVisible" class="ml-auto mr-2 text-light"><span v-tr>Search on Eye-In|Chercher sur Eye-In</span>
                        </b-nav-item>
                        <b-nav-item v-show="searchVisible">
                            <div id="gcse-container"><div class="gcse-search"></div></div>
                        </b-nav-item>
                        <b-nav-item v-show="searchVisible" @click="searchVisible = !searchVisible"><i
                            class="fal fa-times fa-fw"></i></b-nav-item>
                    </template>
                </b-navbar-nav>
            </b-collapse>
        </b-container>

        <b-modal size="lg" v-model="loginModal" :title="'Customer Sign In|Se connecter'|tr" hide-footer>
            <b-row class="text-center">
                <feature-card class="mb-3" src="img/applications/eye-intelligence.png" href="https://eyeintelligence.com" target="_blank">
                    <h4>Eye-Intelligence</h4>
                    <p v-tr>Our Omnichannel CRM for WiFi & Marketing|Notre CRM Marketing & WiFi Omnichannel</p>
                </feature-card>
                <feature-card class="mb-3" src="img/applications/food-force.png" href="https://portal.thefoodforce.com" target="_blank">
                    <h4>TheFoodForce</h4>
                    <p v-tr>Our Cloud Solution for Restaurants|Notre plateforme pour restaurants</p>
                </feature-card>
                <feature-card class="mb-3" src="img/applications/only1-generation.png" href="https://only1generation.com/login" target="_blank">
                    <h4>Only1 Generation</h4>
                    <p v-tr>Our Communication platform for Elderly|Notre plateforme de communication pour ainés</p>
                </feature-card>
            </b-row>
        </b-modal>

        <b-card class="overlay inverted" v-if="isMobileLayout" id="mobile-site-search" v-show="searchVisible"
                style="height: 170px;">
            <b-card-title class="w-100">
                <b-btn class="float-right text-light" variant="transparent" @click="searchVisible = false"
                       style="margin-top: -5px;"><i class="fal fa-times"></i></b-btn>
                <div v-tr>Search on Eye-In|Rechercher sur Eye-In</div>
            </b-card-title>
            <div id="gcse-container-mobile" class="mt-4">
                <div class="gcse-search"></div>
            </div>
        </b-card>
    </b-navbar>
</template>

<script>
import MenuDropdown from "@/components/menu-dropdown.vue";
import {changeLanguage} from "../../vue-components/helpers/i18n";

export default {
    name: `website-menu`,
    components: {MenuDropdown},
    props: {
        fixed: {type: Boolean, default: false},
        loading: {type: Boolean, default: false}
    },
    data() {
        return {
            searchVisible: false,
            search: ``,
            loginModal: false
        }
    },
    methods: {
        showSearchBar() {
            this.searchVisible = true;
            if (window.google && google.search) {
                const container = document.getElementById(this.isMobileLayout ? `gcse-container-mobile` : `gcse-container`)
                const div = document.createElement(`div`);
                div.className = `gcse-search`;
                div.id = `gcse-search`;
                container.innerHTML = ``;
                container.appendChild(div);
                google.search.cse.element.render({
                    div: `gcse-search`
                });
            } else {
                let script = document.createElement(`script`);
                script.setAttribute(`src`, `https://cse.google.com/cse.js?cx=ccb23d7713b0a4bc8`);
                document.body.appendChild(script);
            }
        },
        changeLanguage() {
            localStorage.setItem(`change-language`, `yes`);
            changeLanguage();
            this.$router.go();
        }
    }
}
</script>

<style lang="scss">
.site-header {
    background: #111;
    font-size: 11pt;
    height: 84px;
    width: 100%;
    padding: 0;

    > hr {
        width: 100%;
        margin: 0;
        border-bottom: 1px solid rgba(white, 0.05);
        //border-top: 1px solid rgba(black, 0.5);
    }

    .site-pre-header {
        text-align: right;
        width: 100%;
        padding: 0;

        .nav-link {
            color: inherit;
            padding: 4px 8px;
            font-size: 11pt;
            transition: color 150ms, background-color 150ms;

            &:hover {
                color: white;
                background-color: rgba(white, 0.2);
            }
        }
    }

    .site-header-container {
        padding: 0.5rem 1rem;
    }

    .nav-link {
        color: rgba(white, 0.8);
        letter-spacing: 0.5px;
        //text-transform: uppercase;

        &.router-link-exact-active {
            color: white;
            //border-bottom: 3px solid #fff;
        }
    }

    .gsc-control-cse {
        background: transparent !important;
        border: transparent !important;
        padding: 0 !important;
        font-family: inherit !important;
        width: 300px !important;
        margin-top: -5px;

        table.gsc-search-box td.gsc-input {
            padding: 0;
            height: 25px;
        }

        .gsc-search-button {
            margin: 0;

            .gsc-search-button-v2 {
                height: 32px;
                padding: 6px 14px;
                border: none;
                border-radius: 0 5px 5px 0 !important;
                border-left: 1px solid #ddd;
                background: #eee;
            }
        }

        .gsc-input-box {
            border: none !important;
            border-radius: 5px 0 0 5px !important;
            height: 32px;
        }

        @media(max-width: 576px) {
            width: 100% !important;
            table.gsc-search-box td {
                vertical-align: top !important;

                .gsib_a {
                    padding: 0 5px !important;
                }
            }
        }
    }
}

@media(min-width: 992px) {
    // Bigger than tablet
    .site-header {
        flex-direction: column;

        .navbar-collapse.show {
            position: fixed;
            width: 100%;
            height: calc(100vh - 84px);
            background: #111;
        }
    }
}

@media(max-width: 992px) {
    // Tablet and Mobile
    .site-header {
        .navbar-collapse.show {
            position: fixed;
            top: 84px;
            left: 0;
            width: 100%;
            height: calc(100vh - 84px);
            max-height: calc(100vh - 84px);
            background: #111;
            padding: 10px;
            pointer-events: all;
            overflow-x: hidden;
            overflow-y: auto;
            z-index: 1000;
        }
    }

    .container-pre-header {
        padding: 0;
    }

    .site-pre-header {
        display: flex;
        width: 100%;

        ::v-deep .nav-item {
            margin: 0 auto !important;
        }

        ::v-deep .nav-link {
            padding: 4px 4px !important;
        }
    }
}
</style>
